export enum RelationshipType {
    OneToOne = 'oneToOne',
    ManyToOne = 'manyToOne',
    ManyToMany = 'manyToMany',
    OneToMany = 'oneToMany',
}